import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import IContract from './IContract';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import Acknowledgement from '../leasing/Acknowledgement';
import Owner from '../tract_detail/Owner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import IOwner from '../IOwner';
import ProvisionClauseLeaseholdXRef from '../ProvisionClauseLeaseholdXRef';
import ExtensionOption from '../ExtensionOption';

export default class BrineLease implements IContract {
    id?: number;
    leaseNumber: number;
    leaseDate?: Date;
    originalGrossAcres?: number;
    originalLessor?: string;
    lessorAka?: string;
    createdByUserId?: number;

    // new fields from the contract side
    clientDocNumber: string;
    leasedBy: string;
    reminderDate?: Date;
    reminderNote: string;
    commitDate?: Date;
    isCommitted?: boolean;
    inHandDate?: Date;
    isInHand?: boolean;
    effectiveDate?: Date;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    isNotOriginalLessee?: boolean;
    originalLessee: string;
    isGeneratedLease?: boolean;
    createdDate?: Date;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    leaseLessorNotes: string;
    legalDescription: string;
    rteLegalDescription: string;
    isFiledByMemo?: boolean;
    isVoid?: boolean;
    voidDate?: Date;
    bonusAmount?: number;
    bonusTypeId?: number;
    volume?: string;
    page?: string;
    instrumentNumber?: string;
    recordedDate?: Date;

    currentHold?: BrineLeaseHold;
    brineLeaseHolds?: Array<BrineLeaseHold>;

    // new fields to track

    // not Mapped
    expirationDate?: Date;
    initialBonus?: number;
    rentTotal?: number;
    totalBonus?: number;
    tracts?: Array<ContractGenerationTractDetail>;
    acknowledgements?: Array<Acknowledgement>;
    amendments?: Array<ContractAmendment>;
    adHocClauses?: Array<ContractAdHocClause>;
    removeClauses?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    invoiceableLookupId?: number;
}

export class BrineLeaseHold {
    id: number;
    brineLeaseId?: number;
    number?: number;
    primaryRentalTerm?: number;
    primaryUnitTypeId?: number;
    primaryRentalAmount?: number;
    primaryRentalFeeTypeId?: number;
    primaryRentalTotal?: number;
    optionTerm?: number;
    optionUnitTypeId?: number;
    optionAmount?: number;
    optionFeeTypeId?: number;
    optionTotal?: number;
    royalty?: number;
    isActive?: boolean;
    isHistorical?: boolean;
    projectId?: number;
    extensionOptionLimit?: number;
    
    // not mapped
    surfaceOwner: IOwner;
    ownershipId?: number;
    contractLookupId?: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    provisionLeaseClauses?: Array<ProvisionClauseLeaseholdXRef>;
    extensionOptions?: Array<ExtensionOption>;
}


// WEBPACK FOOTER //
// ./src/models/contract_types/BrineLease.ts